webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-resource/dist/vue-resource.es2015.js
var vue_resource_es2015 = __webpack_require__("ORbq");

// EXTERNAL MODULE: ./node_modules/classlist-polyfill/src/index.js
var src = __webpack_require__("EKrm");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-integer.js
var is_integer = __webpack_require__("RRo+");
var is_integer_default = /*#__PURE__*/__webpack_require__.n(is_integer);

// EXTERNAL MODULE: ./node_modules/vueisotope/dist/vue_isotope.min.js
var vue_isotope_min = __webpack_require__("jOQl");
var vue_isotope_min_default = /*#__PURE__*/__webpack_require__.n(vue_isotope_min);

// EXTERNAL MODULE: ./node_modules/vue-images-loaded/dist/vueimagesloaded.js
var vueimagesloaded = __webpack_require__("iPd/");
var vueimagesloaded_default = /*#__PURE__*/__webpack_require__.n(vueimagesloaded);

// EXTERNAL MODULE: ./node_modules/vue-gallery/dist/js/vue-gallery.js
var vue_gallery = __webpack_require__("I4KV");
var vue_gallery_default = /*#__PURE__*/__webpack_require__.n(vue_gallery);

// EXTERNAL MODULE: ./node_modules/vue-mugen-scroll/dist/vue-mugen-scroll.common.js
var vue_mugen_scroll_common = __webpack_require__("EbDR");
var vue_mugen_scroll_common_default = /*#__PURE__*/__webpack_require__.n(vue_mugen_scroll_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IsoGallery.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-plusplus, no-bitwise, no-console */






/* harmony default export */ var IsoGallery = ({
  name: 'iso-gallery',
  components: {
    isotope: vue_isotope_min_default.a,
    gallery: vue_gallery_default.a,
    mugenScroll: vue_mugen_scroll_common_default.a
  },
  directives: {
    imagesLoaded: vueimagesloaded_default.a
  },
  data: function data() {
    var _this = this;

    return {
      hostUrl: '',
      nextId: 0,
      galleryIndex: null,
      newImagesLoading: true, // Starts as true, for we need to load the JSON data fist.
      hideInfiniteLoading: false,
      rawData: {
        data: null,
        categoriedIndexes: []
      },
      tiles: [],
      filterByThisCategory: 0,
      isotopeOptions: {
        itemSelector: '.RL-IsoGallery__tile',
        percentPosition: true,
        masonry: {
          gutter: '.RL-IsoGallery__gutter'
        },
        getFilterData: [function (tile) {
          return ~tile.categories.indexOf(_this.filterByThisCategory);
        }],
        getSortData: {
          id: 'id'
        }
      }
    };
  },

  computed: {
    filteredTiles: function filteredTiles() {
      var _this2 = this;

      return this.tiles.filter(function (tile) {
        return ~tile.categories.indexOf(_this2.filterByThisCategory);
      });
    },
    gallerySrcs: function gallerySrcs() {
      return this.filteredTiles.map(function (tile) {
        return tile.src;
      });
    },
    galleryCaptions: function galleryCaptions() {
      return this.filteredTiles.map(function (tile) {
        return tile.caption;
      });
    }
  },
  methods: {
    /**
     * Get JSON data from WordPress.
     */
    loadJSON: function loadJSON() {
      var _this3 = this;

      this.hostUrl = window.location.hostname === 'localhost' ? 'https://easy-visual.local' : '';
      // @todo @alvar remove when ready for production. Not breaking.
      var temporaryUrlCheck = ~window.location.pathname.indexOf('photography-new') ? '/photography-new' : '';
      var lang = document.documentElement.lang;
      // Default 'picked' category.
      this.filterByThisCategory = lang === 'fi' ? 41 // Finnish 'Valitut'
      : 43; // English 'Picked'
      var jsonPath = '/wp-json/wp/v2/gallery-image?per_page=99999';
      var docLang = '&lang=' + lang;
      this.$http.get(this.hostUrl + temporaryUrlCheck + jsonPath + docLang).then(function (response) {
        if (response.data && response.data) {
          _this3.parseRawData(response.data);
        }
      });
    },

    /**
     * Parses the WordPress JSON data into an array matrix with
     * category IDs as keys, pointing to image wrapper IDs.
     */
    parseRawData: function parseRawData(data) {
      if (data.constructor === Array && data.length) {
        this.rawData.data = data;
        var categoriedIndexes = {};

        // Sort data indexes into categories
        data.forEach(function (el, i) {
          el.categories.forEach(function (cat) {
            categoriedIndexes[cat] = categoriedIndexes[cat] ? categoriedIndexes[cat] : [];
            categoriedIndexes[cat].push(i);
          });
        });

        this.rawData.categoriedIndexes = categoriedIndexes;
        this.newImagesLoading = 0;
        this.loadMore();
      } else {
        // Hide loading circle if no data to parse. (@todo @alvar, can be made clearer?)
        this.hideInfiniteLoading = true;
        // eslin
        console.error('IsoGallery: No data to parse from JSON.');
      }
    },

    /**
     * Checks which images we need to load next from the JSON data.
     */
    loadMore: function loadMore() {
      var indexes = this.rawData.categoriedIndexes[this.filterByThisCategory] || [];
      var imagesToLoad = 10;
      imagesToLoad = indexes.length < imagesToLoad ? indexes.length : imagesToLoad;

      while (imagesToLoad && indexes.length) {
        var item = this.rawData.data[indexes[0]];
        var image = null;
        var src = '';
        var thumbnail = '';
        // Check if the item has an image, and if it has been loaded.
        try {
          image = item.acf.gallery_image;
          src = item.acf.gallery_image.sizes['gallery-image'];
          thumbnail = item.acf.gallery_image.sizes['gallery-thumbnail'];
        } catch (e) {
          // Just trying, not catching!
          // console.log('skipped');
        }

        if (src) {
          this.newImagesLoading++;
          // Add image to load queue.
          this.tiles.push({
            id: this.nextId++,
            src: this.hostUrl + src,
            thumbnail: this.hostUrl + thumbnail,
            alt: image.alt,
            caption: image.caption,
            categories: item.categories
          });

          // Deleting image data, as we only need to download it once.
          delete this.rawData.data[indexes[0]];
          // The image has been added to load queue.
          imagesToLoad--;
        }

        // Remove index from category, as the image has been received
        // for loading (now or before from an other category).
        indexes.shift();
      }

      // No more need to load images for this category.
      if (!indexes.length) {
        this.hideInfiniteLoading = true;
      }
    },

    /**
     * This is called when an image is loaded.
     */
    imageLoaded: function imageLoaded(instance) {
      var instanceElement = instance.elements[0];
      if (instance.hasAnyBroken) {
        // eslint-disable-next-line no-underscore-dangle
        var brokenIndex = instanceElement.__underlying_element.index;
        this.tiles[brokenIndex].alt = '';
        this.tiles[brokenIndex].isBroken = 'is-broken';
      }
      this.$refs.isotope.layout();
      // for mobile
      if (!instance.hasAnyBroken) {
        instanceElement.classList.add('is-visible');
      }
      // If lightbox gallery is currently open, refresh it.
      this.refreshGallery();
      // This is for checking if we still need more images
      // especially on first load (to fill the screen).
      if (! --this.newImagesLoading && this.isInOrAboveViewport(this.$refs.mugenScroll.$el)) {
        this.loadMore();
      }
    },

    /**
     * Filter gallery and tiles.
     */
    filterGallery: function filterGallery(category) {
      // If the category is already the same or not an interger, don't filter the list.
      if (category === this.filterByThisCategory || !is_integer_default()(category)) {
        return;
      }
      this.filterByThisCategory = category;
      this.$refs.isotope.filter(0);
      // Check if we need more images after filtering (to fill the screen).
      if (!this.newImagesLoading) {
        // Show infinite loader.
        this.hideInfiniteLoading = false;
        // Check if we need more tiles
        if (this.tiles.length < 10 || this.isInOrAboveViewport(this.$refs.mugenScroll.$el)) {
          this.loadMore();
        }
      }
    },

    /**
     * Open the lightbox gallery.
     */
    openGallery: function openGallery(tile) {
      var galleryIndex = this.gallerySrcs.indexOf(tile.src);
      this.galleryIndex = galleryIndex !== -1 ? galleryIndex : tile.id;
    },

    /**
     * Fires when sliding (and opening) the lightbox gallery.
     *
     * Check if the current open lightbox image has a caption, and applies it.
     * Also, check if we need to load more images.
     */
    onSlide: function onSlide(e) {
      var captionTarget = e.slide;
      if (captionTarget && !captionTarget.getAttribute('data-caption')) {
        var dataIndex = captionTarget.getAttribute('data-index');
        var caption = this.galleryCaptions[dataIndex];
        if (caption) {
          captionTarget.setAttribute('data-caption', caption);
        }
      }

      // When the last slide is within 3 indexes of the current slide, try to load more.
      if (!this.newImagesLoading && e.index + 3 >= this.filteredTiles.length) {
        this.loadMore();
      }
    },

    /**
     * Toggles the visibility of a lightbox image's caption.
     */
    toggleCaption: function toggleCaption(e) {
      var captionTarget = void 0;

      if (e.target.classList.contains('slide')) {
        captionTarget = e.target;
      } else if (e.target.classList.contains('slide-content')) {
        captionTarget = e.target.parentNode;
      }

      if (captionTarget && captionTarget.getAttribute('data-caption')) {
        captionTarget.classList.toggle('show-info');
      }
    },

    /**
     * Refresh the lightbox gallery with new image data.
     */
    refreshGallery: function refreshGallery() {
      if (this.galleryIndex === null) {
        return;
      }

      var galleryInstance = this.$refs.gallery.instance;

      if (galleryInstance && galleryInstance.list.length !== this.gallerySrcs.length) {
        var newItems = this.gallerySrcs.filter(function (item) {
          return !~galleryInstance.list.indexOf(item);
        });
        galleryInstance.add(newItems);
      }
    },

    /**
     * Modified from https://gist.github.com/jjmu15/8646226
     * checking if element top is in or above viewport.
     *
     * @param  {object}  Dom Element
     * @return {Boolean} true if in viewport
     */
    isInOrAboveViewport: function isInOrAboveViewport(element) {
      var rect = element.getBoundingClientRect();
      var html = document.documentElement;
      return rect.top < (window.innerHeight || html.clientHeight) && rect.left >= 0 && rect.right <= (window.innerWidth || html.clientWidth);
    }
  },
  created: function created() {
    this.loadJSON();
  },
  mounted: function mounted() {
    document.getElementById('blueimp-gallery').addEventListener('click', this.toggleCaption);
    var self = this;
    // Add gallery filtering end-point for WordPress
    window.filterIsoGallery = function filterIsoGallery(category) {
      self.filterGallery(category);
    };
  },
  beforeDestroy: function beforeDestroy() {
    document.getElementById('blueimp-gallery').removeEventListener('click', this.toggleCaption);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-849d7de2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IsoGallery.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"RL-IsoGallery"},[_c('gallery',{ref:"gallery",attrs:{"images":_vm.gallerySrcs,"index":_vm.galleryIndex},on:{"close":function($event){_vm.galleryIndex = null},"onslide":_vm.onSlide}}),_vm._v(" "),_c('isotope',{ref:"isotope",attrs:{"item-selector":'RL-IsoGallery__tile',"options":_vm.isotopeOptions,"list":_vm.tiles}},[_vm._l((_vm.tiles),function(tile){return _c('a',{directives:[{name:"images-loaded",rawName:"v-images-loaded",value:(_vm.imageLoaded),expression:"imageLoaded"}],key:tile.id,class:tile.isBroken,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.openGallery(tile)}}},[_c('img',{attrs:{"src":tile.thumbnail,"alt":tile.alt}})])}),_vm._v(" "),_c('div',{key:'$ignore',staticClass:"RL-IsoGallery__gutter"})],2),_vm._v(" "),_c('mugen-scroll',{ref:"mugenScroll",staticClass:"RL-IsoGallery__infinite",class:{'RL-IsoGallery__infinite--hide': _vm.hideInfiniteLoading},attrs:{"handler":_vm.loadMore,"should-handle":!_vm.newImagesLoading}},[_c('div',{staticClass:"RL-IsoGallery__loading",attrs:{"aria-label":"Loading..."}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_IsoGallery = (esExports);
// CONCATENATED MODULE: ./src/components/IsoGallery.vue
function injectStyle (ssrContext) {
  __webpack_require__("rbu8")
  __webpack_require__("iktd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-849d7de2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  IsoGallery,
  components_IsoGallery,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_IsoGallery = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  components: {
    IsoGallery: src_components_IsoGallery
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5382a710","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"app"}},[_c('iso-gallery')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






vue_esm["default"].use(vue_resource_es2015["a" /* default */]);

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "bw+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iktd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rbu8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.aa278327306cf7567ce1.js